import { useEffect, useRef } from 'react';
import {
  subscribeLiveMarketDisplay,
  getLiveMarketQuotesFromClientCache,
  LIVE_MARKET_DISPLAY_REFRESH_MS
} from '../utils/liveMarketData';
import { isAuthenticated } from '../utils/authFetch';

/**
 * Background live display from client cache (members only; global 180s notify + local 180s backup).
 * @param {object} options
 * @param {boolean} [options.enabled=true]
 * @param {string[]|null} [options.symbolIds=null] - null = full quote map
 * @param {(live: { quotes: Object }) => void} options.onApply
 */
export function useLiveMarketDisplay({ enabled = true, symbolIds = null, onApply }) {
  const onApplyRef = useRef(onApply);
  const symbolIdsKey = symbolIds == null ? '' : symbolIds.join(',');

  useEffect(() => {
    onApplyRef.current = onApply;
  }, [onApply]);

  useEffect(() => {
    if (!enabled || typeof onApplyRef.current !== 'function') return;

    const run = () => {
      if (!isAuthenticated()) return;
      const live = getLiveMarketQuotesFromClientCache(
        symbolIds && symbolIds.length > 0 ? symbolIds : null
      );
      if (live && onApplyRef.current) {
        onApplyRef.current(live);
      }
    };

    run();
    const unsubGlobal = subscribeLiveMarketDisplay(run);
    const localIntervalId = setInterval(run, LIVE_MARKET_DISPLAY_REFRESH_MS);

    return () => {
      unsubGlobal();
      clearInterval(localIntervalId);
    };
  }, [enabled, symbolIdsKey]);
}
